// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#undo-redo-buttons {
  position: absolute;
  display: flex;
  justify-content: space-evenly;
  background: var(--palette-background-color, #fff);
  border: 1px solid var(--palette-border-color, #e0e0e0);
  border-radius: 2px;
}

#undo-redo-buttons:not(.two-columns) {
  width: 48px;
  height: 94px;
  flex-direction: column;
}

#undo-redo-buttons.two-columns {
  width: 94px;
  height: 48px;
  flex-direction: row;
}

#undo-redo-buttons svg {
  margin: 0;
  padding: 0;
  width: 25px;
  height: 25px;
}

#undo-redo-buttons button {
  display: flex;
  justify-content: center;
  align-items: center;
  all: unset;
  box-sizing: border-box;
  text-align: center;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  line-height: inherit;
}

#undo-redo-buttons:not(.two-columns) button {
  padding: 7px 0 0;
  margin: 0 4px;
}

#undo-redo-buttons.two-columns button {
  padding: 4px 7px 0 7px;
  margin: 4px 0;
}

#undo-redo-buttons button:disabled {
  opacity: 0.5;
}

#undo-redo-buttons button:hover {
  cursor:pointer;
}

#undo-redo-buttons button:hover:disabled {
  cursor: not-allowed;
}

#undo-redo-buttons button:not(:disabled):hover svg {
  fill: var(--palette-entry-hover-color, #0086e6);
}
`, "",{"version":3,"sources":["webpack://./src/App/Pages/Diagram/features/undoRedo/undoRedoButtons.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,iDAAiD;EACjD,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["#undo-redo-buttons {\n  position: absolute;\n  display: flex;\n  justify-content: space-evenly;\n  background: var(--palette-background-color, #fff);\n  border: 1px solid var(--palette-border-color, #e0e0e0);\n  border-radius: 2px;\n}\n\n#undo-redo-buttons:not(.two-columns) {\n  width: 48px;\n  height: 94px;\n  flex-direction: column;\n}\n\n#undo-redo-buttons.two-columns {\n  width: 94px;\n  height: 48px;\n  flex-direction: row;\n}\n\n#undo-redo-buttons svg {\n  margin: 0;\n  padding: 0;\n  width: 25px;\n  height: 25px;\n}\n\n#undo-redo-buttons button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  all: unset;\n  box-sizing: border-box;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  line-height: inherit;\n}\n\n#undo-redo-buttons:not(.two-columns) button {\n  padding: 7px 0 0;\n  margin: 0 4px;\n}\n\n#undo-redo-buttons.two-columns button {\n  padding: 4px 7px 0 7px;\n  margin: 4px 0;\n}\n\n#undo-redo-buttons button:disabled {\n  opacity: 0.5;\n}\n\n#undo-redo-buttons button:hover {\n  cursor:pointer;\n}\n\n#undo-redo-buttons button:hover:disabled {\n  cursor: not-allowed;\n}\n\n#undo-redo-buttons button:not(:disabled):hover svg {\n  fill: var(--palette-entry-hover-color, #0086e6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
